import React from "react"

const ControlButton = ({ iconClass, handler }) => (
  <a className='control-button' onClick={ handler }>
    <span className={ iconClass }></span>
  </a>
)

export default ControlButton
